import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import {createModal} from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({})
  .set('ContactData', new Immutable.Map({}))
  .set('Avisos', new Immutable.List([]))
  .set('GetListMensajesPaginacion', new Immutable.Map({}))

/* Types */
export const ACTION_SEARCH_CONTACT_DATA = 'ACTION_SEARCH_CONTACT_DATA'
export const ACTION_SEARCH_AVISOS = 'ACTION_SEARCH_AVISOS'
export const ACTION_GET_MENSAJES_PAGINACION = "ACTION_GET_MENSAJES_PAGINACION"


/* Reducer */
export default (state = initialState, action) => {

  switch (action.type) {

    case ACTION_SEARCH_CONTACT_DATA:
      return state.set('ContactData', new Immutable.Map(action.Obj))
    case ACTION_SEARCH_AVISOS:
      return state.set('Avisos', new Immutable.List(action.Obj))
    case ACTION_GET_MENSAJES_PAGINACION:
      return state.set('GetListMensajesPaginacion', new Immutable.Map(action.Obj))
    default:
      return state;
  }
};

/* Action Creators */

export const getContactData = (idDonataria) => {
  return (dispatch) => {

    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/bpm/getContactData',
      method: "POST",
      data: {idDonataria},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      dispatch({type: ACTION_SEARCH_CONTACT_DATA, Obj: response.data})
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}


export const getAvisosDonataria = (form) => {
  return (dispatch) => {

    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getAvisosDonataria',
      method: "POST",
      data: { ...form },
      headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      dispatch({type: ACTION_SEARCH_AVISOS, Obj: response.data.mensajes})
      dispatch({ type: ACTION_GET_MENSAJES_PAGINACION, Obj: response.data.paginacion })
    }).catch(error => {
      dispatch(isLoading(false))
      console.log(error)
    })
  }
}

export const saveAvisosDonataria = (form) => {
  return (dispatch) => {
    let temp = {
      idDonataria: form.idDonataria,
      ejecutivo: form.ejecutivo,
      aviso: form.aviso,
      usuario: form.nombreDonataria
    }
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/saveAvisosDonataria',
      method: "POST",
      data: {...temp},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const sendAvisosDonataria = (form) => {
  return (dispatch) => {
    let temp = {
      idDonataria: form.idDonataria,
      nombreDonataria: form.nombreDonataria,
      ejecutivo: {
        idUsuario: form.ejecutivo
      },
      aviso: form.aviso
    }
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/bpm/sendAvisosDonataria',
      method: "POST",
      data: {...temp},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const deleteAvisosDonataria = (idValor) => {
  return (dispatch) => {
    let temp = {
      id: idValor,
      usuario: sessionStorage.uid
    }
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/deleteAvisosDonataria',
      method: "POST",
      data: {...temp},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const clearContactData = () => {

	return (dispatch) => {

		dispatch({ type: ACTION_SEARCH_CONTACT_DATA, Obj: {} })
		dispatch({ type: ACTION_SEARCH_AVISOS, Obj: [] })

	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/ContactData/ContactData.js